import React from 'react';

const Loadable = React.lazy(() => import('../../../pages/Stats/NotionTemplate/NotionTemplate'));

export default Loadable;
